/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { mainContext } from "reducer";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";
import MessageModal from "components/Modals/MessageModal.js";
import AssetsModal from "components/Modals/AssetsModal.js";
import ErrorModal from "components/Modals/ErrorModal.js";
import { t, Truncate } from "utils/text.js";
import Draw from "components/Draw.js";
import Fixed from "components/Fixed.js";
import { getRemainedNFT } from "service.js";
import { CONTRACT, TRONSCAN } from "constants.js";

export default function Index() {
    const { state } = useContext(mainContext);
    const { account } = state;

    const [rank, setRank] = useState(1);
    const [regular, setRegular] = useState(0);
    const [rare, setRare] = useState(0);
    const [epic, setEpic] = useState(0);
    const [legendary, setLegendary] = useState(0);

    useEffect(async () => {
        let data = await getRemainedNFT();
        setRegular(data.regularCount);
        setRare(data.rareCount);
        setEpic(data.epicCount);
        setLegendary(data.legendaryCount);
    }, []);

    return (
        <>
            <IndexNavbar />

            <section className="section_1">
                <div className="container mx-auto" style={{ paddingTop: "15rem" }}>
                    <div className="w-full flex flex-wrap justify-between items-center ">
                        <div className="w-full md:w-2/5">
                            <img src={require("../assets/img/header.png").default} />
                        </div>
                        <div className="w-full md:w-3/5 mt">
                            <p className="p1 whitespace-nowrap">{t("section_1_p1")}</p>
                            <p className="p2 whitespace-nowrap">APENFT VIP Club</p>
                            <p className="p3">
                                {t("section_1_p3")} {t("section_1_p4")}
                            </p>
                            <div className="p4 mt-2 flex items-center whitespace-nowrap">
                                <i className="fas fa-globe mr-4"></i>
                                <span>{t("contract_address")}</span>
                                <a
                                    className="mx-6"
                                    href={TRONSCAN + "/#/contract/" + CONTRACT}
                                    target="_blank">
                                    <Truncate>{CONTRACT}</Truncate>
                                </a>
                                {/*<img className='tronLink cursor-pointer' src={require('../assets/img/add2TronLink.png').default} onClick={()=>{TronLinkClient.addTokenToTronLink()}}/>*/}
                            </div>
                            <div className="p5 flex items-center whitespace-nowrap">
                                <i className="fas fa-shopping-cart mr-4"></i>
                                {/* <i className="fas fa-globe mr-4"></i> */}

                                <a href="https://apenft.io/collections/apenft-vip-club" target="_blank">
                                    <span>{t("to_market")}</span>
                                </a>
                                {/*<img className='tronLink cursor-pointer' src={require('../assets/img/add2TronLink.png').default} onClick={()=>{TronLinkClient.addTokenToTronLink()}}/>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_2">
                <div className="container mx-auto" style={{ paddingTop: "15rem" }}>
                    <div className="w-full flex flex-wrap justify-between items-center ">
                        <div className="left w-full md:w-3/5">
                            <div className="whitespace-nowrap">
                                <p>{t("section_2_span_1")}</p>
                                <p>{t("section_2_span_2")}</p>
                            </div>
                            <p>
                                {t("section_2_p1_1")}
                                <strong>10,000</strong>
                                {t("section_2_p1_2")}
                            </p>
                            <br />
                            <p>{t("section_2_p2")}</p>

                            <button
                                className="focus:outline-none"
                                onClick={() => {
                                    window.open("https://discord.com/invite/SgrbAYKWKk");
                                }}>
                                {t("join")} VIP CLUB
                            </button>
                        </div>
                        <div className="hidden md:block md:w-2/5">
                            <img src={require("../assets/img/section2.png").default} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_3">
                <div className="container mx-auto" style={{ paddingTop: "15rem" }}>
                    <div className="w-full outer_div">
                        <div className="w-full flex flex-wrap justify-between">
                            <div
                                className={
                                    "relative w-1/4 cursor-pointer height " + (rank === 1 ? "selected" : "")
                                }
                                onClick={() => {
                                    setRank(1);
                                }}>
                                <div className="nft_balance absolute flex flex-col items-start justify-center">
                                    <img src={require("../assets/img/oval.png").default} />
                                    <p className="p1 text-center">{t("regular")}</p>
                                    <p className="p2">
                                        {regular} {t("section_3_rank1_p2")}
                                    </p>
                                </div>
                            </div>
                            <div
                                className={
                                    "relative w-1/4 cursor-pointer height " + (rank === 2 ? "selected" : "")
                                }
                                onClick={() => {
                                    setRank(2);
                                }}>
                                <div className="nft_balance absolute flex flex-col items-start justify-center">
                                    <img src={require("../assets/img/tri.png").default} />
                                    <p className="p1 text-center">{t("rare")}</p>
                                    <p className="p2">
                                        {rare} {t("section_3_rank2_p2")}
                                    </p>
                                </div>
                            </div>
                            <div
                                className={
                                    "relative w-1/4 cursor-pointer height " + (rank === 3 ? "selected" : "")
                                }
                                onClick={() => {
                                    setRank(3);
                                }}>
                                <div className="nft_balance absolute flex flex-col items-start justify-center">
                                    <img src={require("../assets/img/rect.png").default} />
                                    <p className="p1 text-center">{t("epic")}</p>
                                    <p className="p2">
                                        {epic} {t("section_3_rank3_p2")}
                                    </p>
                                </div>
                            </div>
                            <div
                                className={
                                    "relative w-1/4 cursor-pointer height " + (rank === 4 ? "selected" : "")
                                }
                                onClick={() => {
                                    setRank(4);
                                }}>
                                <div className="nft_balance absolute flex flex-col items-start justify-center">
                                    <img src={require("../assets/img/path.png").default} />
                                    <p className="p1 text-center">{t("legendary")}</p>
                                    <p className="p2">
                                        {legendary} {t("section_3_rank4_p2")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            {rank === 1 && (
                                <>
                                    <div className="title_main">{t("section_3_rank1_title")}</div>

                                    <div className="text_area">
                                        <p>{t("section_3_rank_text_p1")}</p>
                                        <p>· $NFT \ TRX \ BTT \ JST \ SUN \ WIN</p>
                                        <p>· WINNFTHORSE</p>
                                        <p>· BAYCTRON</p>
                                    </div>

                                    <div className="footer">
                                        <p>
                                            {t("section_3_rank_foot_p1_1")}{" "}
                                            <span className="purple">{"$10,000"}</span> {" <= "}{" "}
                                            {t("asset_value")} {" < "}{" "}
                                            <span className="purple">{"$100,000"}</span>{" "}
                                            {t("section_3_rank_foot_p1_2")} {t("regular")} {t("genesis")} NFT
                                        </p>
                                        <p>{t("section_3_rank1_foot_p2")}</p>
                                        <p>※ {t("section_3_rank_foot_p3")}</p>
                                    </div>
                                </>
                            )}
                            {rank === 2 && (
                                <>
                                    <div className="title_main">{t("section_3_rank2_title")}</div>

                                    <div className="text_area ">
                                        <p>{t("section_3_rank_text_p1")}</p>
                                        <p>· $NFT \ TRX \ BTT \ JST \ SUN \ WIN</p>
                                        <p>· WINNFTHORSE</p>
                                        <p>· BAYCTRON</p>
                                    </div>

                                    <div className="footer">
                                        <p>
                                            {t("section_3_rank_foot_p1_1")}{" "}
                                            <span className="purple">{"$100,000"}</span> {" <= "}{" "}
                                            {t("asset_value")} {" < "}{" "}
                                            <span className="purple">{"$1,000,000"}</span>{" "}
                                            {t("section_3_rank_foot_p1_2")} {t("rare")} {t("genesis")} NFT
                                        </p>
                                        <p>{t("section_3_rank2_foot_p2")}</p>
                                        <p>※ {t("section_3_rank_foot_p3")}</p>
                                    </div>
                                </>
                            )}
                            {rank === 3 && (
                                <>
                                    <div className="title_main">{t("section_3_rank3_title")}</div>

                                    <div className="text_area ">
                                        <p>{t("section_3_rank_text_p1")}</p>
                                        <p>· $NFT \ TRX \ BTT \ JST \ SUN \ WIN</p>
                                        <p>· WINNFTHORSE</p>
                                        <p>· BAYCTRON</p>
                                    </div>

                                    <div className="footer">
                                        <p>
                                            {t("section_3_rank_foot_p1_1")} {t("asset_value")}
                                            {" >= "} <span className="purple">{"$1,000,000"}</span>{" "}
                                            {t("section_3_rank_foot_p1_2")} {t("epic")} {t("genesis")} NFT
                                        </p>
                                        <p>{t("section_3_rank3_foot_p2")}</p>
                                        <p>※ {t("section_3_rank_foot_p3")}</p>
                                    </div>
                                </>
                            )}
                            {rank === 4 && (
                                <>
                                    <div className="title_main">{t("section_3_rank4_title")}</div>

                                    <div className="footer">
                                        <strong>{t("section_3_rank4_footer_p")}</strong>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_4">
                <div className="container mx-auto" style={{ paddingTop: "15rem", paddingBottom: "15rem" }}>
                    <div className="w-full flex flex-col">
                        <div className="title font-semibold">
                            <p>{t("section_4_title_p1")}</p>
                            <p>{t("section_4_title_p2")}</p>
                        </div>
                        <div className="content">
                            <p>{t("section_4_content_p1")}</p>
                            <p>{t("section_4_content_p2")}</p>
                            <p>{t("section_4_content_p3")}</p>
                            <p>{t("section_4_content_p4")}</p>
                            <p>{t("section_4_content_p5")} </p>
                            <p>{t("section_4_content_p6")}</p>
                        </div>

                        <button
                            onClick={() => {
                                window.open("https://discord.com/invite/SgrbAYKWKk");
                            }}>
                            <strong>{t("section_4_button")}</strong>
                        </button>
                    </div>
                </div>
            </section>

            {!account.canClaim && account.rank > 0 && (
                <section className="section_5">
                    <div className="container mx-auto">
                        <div className="w-full flex flex-col md:flex-row flex-wrap justify-center items-center text-center outer_div">
                            <p>
                                {" "}
                                {t("already_claimed_1")} <br /> {t("already_claimed_2")}
                            </p>
                        </div>
                    </div>
                </section>
            )}
            {account.rank === 0 && (
                <section className="section_5">
                    <div className="container mx-auto">
                        <div className="w-full flex flex-col md:flex-row flex-wrap justify-center items-center text-center outer_div">
                            <p> {t("assets_not_enough")} </p>
                        </div>
                    </div>
                </section>
            )}

            {account.canClaim && account.rank > 0 && (
                <section className="section_6" id="draw">
                    <Draw />
                </section>
            )}

            <Footer />

            <MessageModal />
            <AssetsModal />
            <ErrorModal />

            {/*<Fixed />*/}
        </>
    );
}
